import { createReducer } from '../utils/reducers';
import { SETUP_PAYWALL } from '../actions/paywall';

const INITIAL_STATE = {};

export default createReducer(INITIAL_STATE, {
    [SETUP_PAYWALL]: (state, action) => {
        return {
            ...state,
            ...action.data,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/paywall.js